// extracted by mini-css-extract-plugin
var _1 = "NskZLdW4";
var _2 = "xuueSOa7";
var _3 = "g2UeEqgd";
export { _1 as "errorPage", _2 as "link", _3 as "text" }
